import React, { Component } from 'react';
import { Nav, NavItem } from 'reactstrap';
import { Link } from "react-router-dom";
import './aside.scss';
import { ROLE_ADMIN, ROLE_ANALYST } from '../../constants';
import classnames from 'classnames';

class AdminAside extends Component {
    constructor(props) {
        super(props);
        this.state = {
            riskFactorsCollapsed: true,
            creditLimitCollapsed:true,
            scorecardCollapsed: true,
            corporateCollapsed: true,
            correspondentCollapsed: true,
            userManagementCollapsed:true,
            analystCollapsed: true,
            newsCollapsed: true,
            caseCollapsed: true,
            configurationCollapsed: true,
            riskFactorOverridingCollapsed: true,
            credenceCollapsed: true,
            globalCollapsed: true,
            monitoringCollapsed : true,
            ewsCollapsed : true,
            counterpartyCollapsed: true,
            kycUsageCollapsed : true,
            misCollapsed :true,
            meteringCollapsed : true
        };
    }

    render() {
        const location = this.props.history.location;
        const scope = this.props.userDetails.scopes[0]
        return (
            <aside className={location.pathname.includes("case/companysearch/") ? "app-aside disabled" : "app-aside"}>
                <Nav vertical>

                    {/* Dashboard */}
                    {/* {(scope === ROLE_ADMIN) ? <NavItem>
                        <Link className={location.pathname === '/' ? 'nav-link active' : 'nav-link'}
                            onClick={this.props.showHideMenu} to="/">DASHBOARD</Link>
                    </NavItem> : ''} */}

                    {/* Cases */}
                    <NavItem>
                        <Link className={!this.state.caseCollapsed ? "nav-link active" : "nav-link"} onClick={(e) => {
                            e.preventDefault();
                            this.setState((prevState) => ({ caseCollapsed: !prevState.caseCollapsed }));
                            return false;
                        }} to="">Cases<i
                            className={!this.state.caseCollapsed ? "icon-arrow-up" : "icon-arrow-down"}></i></Link>
                        <Nav className={this.state.caseCollapsed ? 'collapse' : ''} vertical>
                            <NavItem>
                                <Link
                                    className={location.pathname === "/case/create" ? "nav-link text-white" : "nav-link"}
                                    to="/case/create">Create Cases</Link>
                            </NavItem>
                            <NavItem>
                                <Link className={location.pathname === "/case/create/bulk" ? "nav-link text-white" : "nav-link"}
                                    to="/case/create/bulk">Create Bulk Case</Link>
                            </NavItem>
                            <NavItem>
                                <Link className={location.pathname === "/case" ? "nav-link text-white" : "nav-link"}
                                    to="/case">View All Cases</Link>
                            </NavItem>
                            <NavItem>
                                <Link className={location.pathname === "/case/update/bulk" ? "nav-link text-white" : "nav-link"}
                                    to="/case/update/bulk">Bulk Case Update</Link>
                            </NavItem>
                            <NavItem>
                                <Link className={location.pathname === "/case/api" ? "nav-link text-white" : "nav-link"}
                                    to="/case/api">API Cases</Link>
                            </NavItem>
                        </Nav>
                    </NavItem>

                    {/* International API Dashboard */}
                    <NavItem>
                        <Link className={location.pathname === "/international" ? "nav-link active" : "nav-link"} 
                                    to="/international">International</Link>
                    </NavItem>

                    {/* Early Warning System */}
                     {(scope === ROLE_ADMIN) ? <NavItem>
                        <Link className={!this.state.ewsCollapsed ? "nav-link active" : "nav-link"} onClick={(e) => {
                            e.preventDefault();
                            this.setState((prevState) => ({ ewsCollapsed: !prevState.ewsCollapsed }));
                            return false;
                        }} to="">Early Warning System<i className={!this.state.ewsCollapsed ? "icon-arrow-up" : "icon-arrow-down"}></i></Link>
                        <Nav className={this.state.ewsCollapsed ? 'collapse' : ''} vertical>
                             <NavItem>
                                <Link className="nav-link" to="/ews">EWS Dashboard</Link>
                            </NavItem>
                            <NavItem>
                                <Link className="nav-link" to="/ews/bulk-upload-download">Bulk Upload/Download</Link>
                            </NavItem>
                            <NavItem>
                                <Link className="nav-link" to="/ews/publish-unpublish">Publish/Unpublish</Link>
                            </NavItem>
                            <NavItem>
                                <Link className="nav-link" to="/ews/report">Report Download/Email</Link>
                            </NavItem>
                            <NavItem>
                                <Link className="nav-link" to="/ews/financial-data">Add Financial Parameters</Link>
                            </NavItem>
                        </Nav>
                    </NavItem> : ''}

                    {/* Corporates */}
                    {(scope === ROLE_ADMIN) ? <NavItem>
                        <Link className={!this.state.corporateCollapsed ? "nav-link active" : "nav-link"} onClick={(e) => {
                            e.preventDefault();
                            this.setState((prevState) => ({ corporateCollapsed: !prevState.corporateCollapsed }));
                            return false;
                        }} to="">Corporates<i className={!this.state.corporateCollapsed ? "icon-arrow-up" : "icon-arrow-down"}></i></Link>
                        <Nav className={this.state.corporateCollapsed ? 'collapse' : ''} vertical>
                            <NavItem>
                                <Link className="nav-link" to="/corporate/list">View All Corporates</Link>
                            </NavItem>
                            <NavItem>
                                <Link className="nav-link" to="/corporate/diyreportsetup">Generate Report</Link>
                            </NavItem>

                            <NavItem>
                                <Link className="nav-link" to="/corporate/cug-data-upload">CUG Data Upload</Link>
                            </NavItem>
                            <NavItem>
                                <Link className="nav-link" to="/corporate/defaultProduct">Default Product</Link>
                            </NavItem>
                             <NavItem>
                                <Link className="nav-link" to="/corporate/CreateBulkEndUser">Create Bulk End User</Link>
                            </NavItem>
                        </Nav>
                    </NavItem> : ''}

                    {/* Metering */}
                    {(scope === ROLE_ADMIN) ? <NavItem>
                        <Link className={!this.state.meteringCollapsed ? "nav-link active" : "nav-link"} onClick={(e) => {
                            e.preventDefault();
                            this.setState((prevState) => ({ meteringCollapsed: !prevState.meteringCollapsed }));
                            return false;
                        }} to="">
                            Metering
                            <i className={!this.state.meteringCollapsed ? "icon-arrow-up" : "icon-arrow-down"}></i>
                        </Link>
                        <Nav className={this.state.meteringCollapsed ? 'collapse' : ''} vertical>
                            <NavItem>
                                <Link className="nav-link" to="/Metering-System">Metering Master </Link>
                            </NavItem>
                            <NavItem>
                                <Link className="nav-link" to="/corporate/meteringStats">Metering Stats</Link>
                            </NavItem>
                            <NavItem>
                                <Link className="nav-link" to="/corporate/caseCount">Corporate case count</Link>
                            </NavItem>
                        </Nav>
                    </NavItem> : ''}

                    {/* Monitoring */}
                    {(scope === ROLE_ADMIN) ? <NavItem>
                        <Link className={!this.state.monitoringCollapsed ? "nav-link active" : "nav-link"} onClick={(e) => {
                            e.preventDefault();
                            this.setState((prevState) => ({ monitoringCollapsed: !prevState.monitoringCollapsed }));
                            return false;
                        }} to="">Monitoring<i className={!this.state.monitoringCollapsed ? "icon-arrow-up" : "icon-arrow-down"}></i></Link>
                        <Nav className={this.state.monitoringCollapsed ? 'collapse' : ''} vertical>
                             <NavItem>
                                <Link className="nav-link" to="/monitoring/create">Download/Upload Details</Link>
                            </NavItem>
                            <NavItem>
                                <Link className="nav-link" to="/monitoring/data-upload">Monitoring old Data Upload</Link>
                            </NavItem>

                            <NavItem>
                                <Link className="nav-link" to="/monitoring/initiation">Initiate Monitoring</Link>
                            </NavItem>
                            <NavItem>
                                <Link className="nav-link" to="/monitoring/report">Monitoring Report</Link>
                            </NavItem>
                        </Nav>
                    </NavItem> : ''}

                    {/* Counterparties */}
                    {(scope === ROLE_ADMIN) ? <NavItem>
                        <Link className={!this.state.counterpartyCollapsed ? "nav-link active" : "nav-link"} onClick={(e) => {
                            e.preventDefault();
                            this.setState((prevState) => ({ counterpartyCollapsed: !prevState.counterpartyCollapsed }));
                            return false;
                        }} to="">Counterparties<i className={!this.state.counterpartyCollapsed ? "icon-arrow-up" : "icon-arrow-down"}></i></Link>
                        <Nav className={this.state.counterpartyCollapsed ? 'collapse' : ''} vertical>
                             <NavItem>
                                <Link className="nav-link" to="/counterparties/search">Search Counterparty</Link>
                            </NavItem>
                            <NavItem>
                                <Link className='nav-link' to='/counterparties/ratings-data-upload'>Ratings Data Upload</Link>
                            </NavItem>
                            <NavItem>
                                <Link className={location.pathname === "/case/database" ? "nav-link text-white" : "nav-link"}
                                    to="/case/database">Create Database Cases</Link>
                            </NavItem>
                        </Nav>
                    </NavItem> : ''}

                     {/* User-Management */}
                    {(scope === ROLE_ADMIN) ? <NavItem>
                        <Link className={!this.state.userManagementCollapsed ? "nav-link active" : "nav-link"} onClick={(e) => {
                            e.preventDefault();
                            this.setState((prevState) => ({ userManagementCollapsed: !prevState.userManagementCollapsed }));
                            return false;
                        }} to="">
                            User-Management
                            <i className={!this.state.userManagementCollapsed ? "icon-arrow-up" : "icon-arrow-down"}></i>
                        </Link>
                        <Nav className={this.state.userManagementCollapsed ? 'collapse' : ''} vertical>
                            <NavItem>
                                <Link className="nav-link" to="/user-management/all-users">View all Users</Link>
                            </NavItem>
                        </Nav>
                    </NavItem> : ''}

                    {/* Section Templates */}
                    {(scope === ROLE_ADMIN) ? <NavItem>
                        <Link className={!this.state.configurationCollapsed ? "nav-link active" : "nav-link"}
                            onClick={(e) => {
                                e.preventDefault();
                                this.setState((prevState) => ({ configurationCollapsed: !prevState.configurationCollapsed }));
                                return false;
                            }} to="">Section Templates<i
                                className={!this.state.configurationCollapsed ? "icon-arrow-up" : "icon-arrow-down"}></i></Link>
                        <Nav className={this.state.configurationCollapsed ? 'collapse' : ''} vertical>
                            <NavItem>
                                <Link
                                    className={location.pathname === "/sectiontemplate/search" ? "nav-link text-white" : "nav-link"}
                                    to="/sectiontemplate/search">Search Section Template</Link>
                            </NavItem>
                            <NavItem>
                                <Link
                                    className={location.pathname === "/sectiontemplate/create" ? "nav-link text-white" : "nav-link"}
                                    to="/sectiontemplate/create">Create Section Template</Link>
                            </NavItem>
                            <NavItem>
                                <Link
                                    className={location.pathname === "/sectiontemplate/list" ? "nav-link text-white" : "nav-link"}
                                    to="/sectiontemplate/list">View All Section Template</Link>
                            </NavItem>
                        </Nav>
                    </NavItem> : ''}

                    {/* Risk Factors */}
                    {(scope === ROLE_ADMIN) ? <NavItem>
                        <Link className={!this.state.riskFactorsCollapsed ? "nav-link active" : "nav-link"}
                            onClick={(e) => {
                                e.preventDefault();
                                this.setState((prevState) => ({ riskFactorsCollapsed: !prevState.riskFactorsCollapsed }));
                                return false;
                            }} to="/riskfactor/search">Risk Factors<i
                                className={!this.state.riskFactorsCollapsed ? "icon-arrow-up" : "icon-arrow-down"}></i></Link>
                        <Nav className={this.state.riskFactorsCollapsed ? 'collapse' : ''} vertical>
                            <NavItem>
                                <Link
                                    className={location.pathname === '/riskfactor/search' ? 'nav-link text-white' : 'nav-link'}
                                    to="/riskfactor/search">Search Risk Factors</Link>
                            </NavItem>
                            <NavItem>
                                <Link
                                    className={location.pathname === '/riskfactor/create' ? 'nav-link text-white' : 'nav-link'}
                                    to="/riskfactor/create">Create Risk Factor</Link>
                            </NavItem>
                            <NavItem>
                                <Link
                                    className={location.pathname === '/riskfactor/list' ? 'nav-link text-white' : 'nav-link'}
                                    to="/riskfactor/list">View All Risk Factors</Link>
                            </NavItem>
                            <NavItem>
                                <Link onClick={(e) => {
                                    e.preventDefault();
                                    this.setState((prevState) => ({ riskFactorOverridingCollapsed: !prevState.riskFactorOverridingCollapsed }));
                                    return false;
                                }}
                                    className={!this.state.riskFactorOverridingCollapsed ? "nav-link text-white" : "nav-link"}
                                    to="/riskfactor/list">Overriding Risk Factors<i
                                        className={!this.state.riskFactorOverridingCollapsed ? "icon-arrow-up ml-auto" : "icon-arrow-down"}></i></Link>
                                <Nav className={this.state.riskFactorOverridingCollapsed ? 'collapse' : ''}>
                                    <NavItem>
                                        <Link
                                            className={location.pathname === '/riskfactor/overridingriskfactor/create' ? 'nav-link text-white' : 'nav-link'}
                                            onClick={this.handleLogout} to="/riskfactor/overridingriskfactor/create">
                                            Create Overriding Risk Factors
                                        </Link>
                                    </NavItem>
                                    <NavItem>
                                        <Link
                                            className={location.pathname === '/riskfactor/overridingriskfactor/list' ? 'nav-link text-white' : 'nav-link'}
                                            onClick={this.handleLogout} to="/riskfactor/overridingriskfactor/list">
                                            View All Overriding Risk Factors
                                        </Link>
                                    </NavItem>
                                    <NavItem>
                                        <Link
                                            className={location.pathname === '/riskfactor/overridingriskfactor/automated/create' ? 'nav-link text-white' : 'nav-link'}
                                            onClick={this.handleLogout} to="/riskfactor/overridingriskfactor/automated/create">
                                            Create Automated Overriding Risk Factor
                                        </Link>
                                    </NavItem>
                                    <NavItem>
                                        <Link
                                            className={location.pathname === '/riskfactor/overridingriskfactor/automated/list' ? 'nav-link text-white' : 'nav-link'}
                                            onClick={this.handleLogout} to="/riskfactor/overridingriskfactor/automated/list">
                                            View All Automated Overriding Risk Factors
                                        </Link>
                                    </NavItem>
                                </Nav>
                            </NavItem>
                        </Nav>
                    </NavItem> : ''}

                    {/* Credit Limit */}
                    {(scope === ROLE_ADMIN) ? <NavItem>
                        <Link className={!this.state.creditLimitCollapsed ? "nav-link active" : "nav-link"}
                            onClick={(e) => {
                                e.preventDefault();
                                this.setState((prevState) => ({ creditLimitCollapsed: !prevState.creditLimitCollapsed }));
                                return false;
                            }} to="/creditlimit/create">Credit Limit<i
                                className={!this.state.creditLimitCollapsed ? "icon-arrow-up" : "icon-arrow-down"}></i></Link>
                        <Nav className={this.state.creditLimitCollapsed ? 'collapse' : ''} vertical>
                            <NavItem>
                                <Link
                                    className={location.pathname === '/creditlimit/create' ? 'nav-link text-white' : 'nav-link'}
                                    to="/creditlimit/create">Create Model</Link>
                            </NavItem>
                            <NavItem>
                                <Link
                                    className={location.pathname === '/creditlimit/viewall' ? 'nav-link text-white' : 'nav-link'}
                                    to="/creditlimit/viewall">View All Model</Link>
                            </NavItem>
                        </Nav>
                    </NavItem> : ''}

                    {/* Global Configurations */}
                    {(scope === ROLE_ADMIN) ? <NavItem>
                        <Link className={!this.state.globalCollapsed ? "nav-link active" : "nav-link"} onClick={(e) => {
                            e.preventDefault();
                            this.setState((prevState) => ({ globalCollapsed: !prevState.globalCollapsed }));
                            return false;
                        }} to="">
                            Global Configurations
                            <i className={!this.state.globalCollapsed ? "icon-arrow-up" : "icon-arrow-down"}></i>
                        </Link>
                        <Nav className={this.state.globalCollapsed ? 'collapse' : ''} vertical>
                            <NavItem>
                                <Link
                                    className={location.pathname === "/sectiontemplate/master/list" ? "nav-link text-white" : "nav-link"}
                                    to="/sectiontemplate/master/list">View All Master Key</Link>
                            </NavItem>
                            <NavItem>
                                <Link
                                    className={location.pathname === "/Mis-Form-Fields" ? "nav-link text-white" : "nav-link"}
                                    to="/Mis-Form-Fields">View All Mis Form Fields</Link>
                            </NavItem>
                            <NavItem>
                                <Link
                                    className={location.pathname === "/api-access-manager" ? "nav-link text-white" : "nav-link"}
                                    to="/api-access-manager">Manage API Access</Link>
                            </NavItem>
                            <NavItem>
                                <Link
                                    className={location.pathname === "/Data-Upload" ? "nav-link text-white" : "nav-link"}
                                    to="/Data-Upload">Data Upload</Link>
                            </NavItem>
                            <NavItem>
                                <Link 
                                    className={location.pathname === "/userAccessManagement" ? "nav-link active" : "nav-link"} 
                                    to="/userAccessManagement">User Access Management
                                </Link>
                            </NavItem>
                            
                            <NavItem>
                                <Link
                                    className={location.pathname === "/Partner-Cost" ? "nav-link text-white" : "nav-link"}
                                    to="/Partner-Cost">Partner Cost</Link>
                            </NavItem>

                        </Nav>
                    </NavItem> : ''}

                    {/* Kyc Usage */}
                    {(scope === ROLE_ADMIN) ? <NavItem>
                        <Link className={!this.state.kycUsageCollapsed ? "nav-link active" : "nav-link"} onClick={(e) => {
                            e.preventDefault();
                            this.setState((prevState) => ({ kycUsageCollapsed: !prevState.kycUsageCollapsed }));
                            return false;
                        }} to="">Kyc Usage<i className={!this.state.kycUsageCollapsed ? "icon-arrow-up" : "icon-arrow-down"}></i></Link>
                        <Nav className={this.state.kycUsageCollapsed ? 'collapse' : ''} vertical>
                            <NavItem>
                                <Link className="nav-link" to="/kyc-usage">Stats & Metering</Link>
                            </NavItem>
                            <NavItem>
                                <Link className="nav-link" to="/kyc-usage/pricing">Pricing</Link>
                            </NavItem>
                        </Nav>
                    </NavItem> : ''}

                     {/* Data Extract */}
                     {(scope === ROLE_ADMIN) ? <NavItem>
                        <Link className={!this.state.dataExractCollapsed ? "nav-link active" : "nav-link"} onClick={(e) => {
                            e.preventDefault();
                            this.setState((prevState) => ({ dataExractCollapsed: !prevState.dataExractCollapsed }));
                            return false;
                        }} to="">Data Extract<i className={!this.state.dataExractCollapsed ? "icon-arrow-up" : "icon-arrow-down"}></i></Link>
                        <Nav className={this.state.dataExractCollapsed ? 'collapse' : ''} vertical>
                            <NavItem>
                                <Link className="nav-link" to="/vendor-tracker">Vendor Tracker</Link>
                            </NavItem>
                            <NavItem>
                                <Link className="nav-link" to="/activity-log">Activity Log</Link>
                            </NavItem>
                        </Nav>
                    </NavItem> : ''}
                        
                        {(scope === ROLE_ADMIN) ? <NavItem>
                        <Link className={!this.state.misCollapsed ? "nav-link active" : "nav-link"} onClick={(e) => {
                            e.preventDefault();
                            this.setState((prevState) => ({ misCollapsed: !prevState.misCollapsed }));
                            return false;
                        }} to="">
                            MIS Configurations
                            <i className={!this.state.misCollapsed ? "icon-arrow-up" : "icon-arrow-down"}></i>
                        </Link>
                        <Nav className={this.state.misCollapsed ? 'collapse' : ''} vertical>
                            <NavItem>
                                <Link
                                    className={location.pathname === "/Mis-Team" ? "nav-link text-white" : "nav-link"}
                                    to="/Mis-Team">MIS Team</Link>
                            </NavItem> 
                        </Nav>
                    </NavItem> : ''}
                    
                    {(scope === ROLE_ADMIN) ?<NavItem>
                        <Link className={location.pathname === "/ifscMaster-Upload" ? "nav-link active" : "nav-link"} 
                                    to="/ifscMaster-Upload">IFSC Master Upload</Link>
                        </NavItem>: ''}

                        {(scope === ROLE_ADMIN) ?<NavItem>
                        <Link className={location.pathname === "/localPartyMaster-Upload" ? "nav-link active" : "nav-link"} 
                                    to="/localPartyMaster-Upload">Local Party Master Upload</Link>
                        </NavItem>: ''}

                        {(scope === ROLE_ADMIN) ?<NavItem>
                        <Link className={location.pathname === "/ifscUserMaster-Upload" ? "nav-link active" : "nav-link"} 
                                    to="/ifscUserMaster-Upload">IFSC User Master Upload</Link>
                        </NavItem>: ''}

                        {(scope === ROLE_ADMIN) ?<NavItem>
                        <Link className={location.pathname === "/corporateBillingMaster-Upload" ? "nav-link active" : "nav-link"} 
                                    to="/corporateBillingMaster-Upload">Corporate Billing Master</Link>
                        </NavItem>: ''}

                        {(scope === ROLE_ADMIN) ?<NavItem>
                        <Link className={location.pathname === "/corporateMaster" ? "nav-link active" : "nav-link"} 
                                    to="/corporateMaster">Corporate Master</Link>
                        </NavItem>: ''}

                         {(scope === ROLE_ADMIN) ?<NavItem>
                        <Link className={location.pathname === "/country-industry-reports" ? "nav-link active" : "nav-link"} 
                                    to="/country-industry-reports">Country & Industry Reports</Link>
                        </NavItem>: ''}

                        {(scope === ROLE_ADMIN) ?<NavItem>
                        <Link className={location.pathname === "/support-work-automation" ? "nav-link active" : "nav-link"} 
                                    to="/support-work-automation">Support Work Automation</Link>
                        </NavItem>: ''}
                        
                </Nav>
            </aside>
        );
    }
}

export default AdminAside;
